/**
 * 素材收选
 */
import { connect } from 'react-redux';
import { updaterRoute } from '@/store/menus';
import { getQuery } from '@/common/utils';
import TabNav from '@/components/slide-menu/tab-nav';
import provideSlideMenu from '@/components/slide-menu/provide-slide-menu';

const MaterialCollection = (props) => {
  return (
    <provideSlideMenu.Provider value={{ children: props.children }}>
      <div style={{ display: 'flex', flexDirection: 'column', padding: 15 }}>
        <TabNav filterMenus={(menus) => menus} alignCenter linkParams={{}} />
        <div style={{ flexGrow: '1', minWidth: 0 }}>{props.children}</div>
      </div>
    </provideSlideMenu.Provider>
  );
};

export default connect(undefined, { updaterRoute })(MaterialCollection);
